import { ReactNode, createContext, useContext, useMemo } from 'react';
import { Worksheet } from '../types/worksheet';

type WorksheetContextData = {
    worksheet: Worksheet;
    priorWorksheet?: Worksheet;
};

const WorksheetContext = createContext<WorksheetContextData | undefined>(undefined);

type WorksheetProviderProps = {
    worksheet: Worksheet;
    priorWorksheet?: Worksheet;
    children: ReactNode | ReactNode[];
};

function WorksheetProvider({ worksheet, priorWorksheet, children }: WorksheetProviderProps): JSX.Element {
    const value = useMemo(() => ({ worksheet, priorWorksheet }), [worksheet, priorWorksheet]);
    return <WorksheetContext.Provider value={value}>{children}</WorksheetContext.Provider>;
}

export function useWorksheetContext<T extends Worksheet>(): { worksheet: T; priorWorksheet?: T } {
    const context = useContext(WorksheetContext);
    if (context === undefined) {
        throw new Error('useWorksheetContext must be used within a WorksheetProvider');
    }
    return {
        worksheet: context.worksheet as T,
        priorWorksheet: context.priorWorksheet as T,
    };
}

export default WorksheetProvider;
